// Created from Travelhome\Sitecore\ANWBReizen.Travelhome.Sitecore.Web\ViewModels\ContainerWidth.cs

export enum ContainerWidth {
  Full = 'Full',
  Half = 'Half'
}
